
import axios from "axios";

import { API_URL } from "../config/constants";

const END_POINT = `${API_URL}wallet/`

export const moveDepositRequest = (id, status) => {
    return axios
        .put(`${END_POINT}move-deposit-request/${id}`, {
            status
        })
        .then((response) => {
            return response;
        }).catch(e => {
            return e?.response;
        });
};

export const moveSendToRequest = (id, status) => {
    return axios
        .put(`${END_POINT}move-send-request/${id}`, {
            status
        })
        .then((response) => {
            return response;
        }).catch(e => {
            return e?.response;
        });
};

export const moveWithdrawRequest = (id, status) => {
    return axios
        .put(`${END_POINT}move-withdraw-request/${id}`, {
            status
        })
        .then((response) => {
            return response;
        }).catch(e => {
            return e?.response;
        });
};
